module.exports = __webpack_public_path__ + "img/my_rainbow_5.73b2fe80.jpg";